import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const pointProductRouter: RouteConfig = {
  path: "/points-product",
  name: "points-product",
  component: Layout,
  meta: {
    title: "积分与商品管理",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "/totalPoints",
      name: "/totalPoints",
      component: () => import('@/views/pointsProduct/totalPoints.vue'),
      meta: {
        title: "积分统计管理",
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "/pointDetails",
      name: "/pointDetails",
      component: () => import('@/views/pointsProduct/pointDetails/index.vue'),
      meta: {
        title: "教师的积分详细",
        hidden: true,
        permission: "Pages.Settings.User"
      }
    },
    {
        path: "/pointRules",
        name: "/pointRules",
        component: () => import('@/views/pointsProduct/pointRules/index.vue'),
        meta: {
          title: "积分规则",
          permission: "Pages.Settings.User"
        }
      },
    {
      path: "/editorPointRuls",
      name: "/editorPointRuls",
      component: () => import('@/views/pointsProduct/editorPointRuls/index.vue'),
      meta: {
        title: "编辑规则",
        hidden: true,
        permission: "Pages.Settings.User"
        
      }
    },


  ]
};

export default pointProductRouter;
